export var ToolType;
(function (ToolType) {
    ToolType["CreateSurveysForAppointments"] = "create-surveys-for-appointments";
})(ToolType || (ToolType = {}));
